import { IFlatTourBooking } from '../../types/flatTourBooking';
import { IApplicationState } from '../../types/redux';

export function getFlatTourSchedule(state: IApplicationState): IFlatTourBooking | null {
  return state.flatTourBooking;
}
